import { TableCell } from '@/components/ui/table';
import { useMe } from '@/hooks/use-me';
import { formatEnergy } from '@/utils/format/battery';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type ThroughputTotalCellProps = {
  row: UnitOverviewRow;
};

export function ThroughputTotalCell({ row }: ThroughputTotalCellProps) {
  const me = useMe();

  return (
    <TableCell narrow justify="left" valign="bottom">
      <span className="whitespace-nowrap">
        {typeof row.throughputTotal === 'number'
          ? formatEnergy(row.throughputTotal, me.config.powerUnit)
          : '-'}
      </span>
    </TableCell>
  );
}
